<template>
	<div class="footer">
		<div :class="pageind1 == 0 ? 'mububg' : 'mububg1'"></div>
	  <div class="w1400" :class="isshow? 'footerpc' : 'footerph'">
	    <div v-if="isshow" class="ewmmod" style="opacity:0;">
	    	<div class="">公众号</div>
				<img src="../assets/images/footcode1.png" >
	    </div>
			<div v-if="isshow" class="ewmmod" style="opacity:0;">
				<div class="">视频号</div>
				<img src="../assets/images/footcode2.png" >
			</div>
			<div v-if="isshow" class="ewmmod" style="opacity:0;">
				<div class="">抖音</div>
				<img src="../assets/images/footcode3.png" >
			</div>
			<div class="">
				<div class="footer-wrap footer-nav">
				  <a href="/about?type=&index=0">关于我们</a>
				  <a href="/product?type=&index=2">产品中心</a>
				  <a href="/news?type=&index=1">新闻动态</a>
				  <a href="/yxfw?type=&index=6">服务中心</a>
				</div>
				<div class="footer-wrap clearfix footer-contact">
				  <div class="text-wrap">
				    <div class="wrapper clearfix">
				        <p class="icon-1">全国服务热线：{{values1}}</p>
				        <p class="icon-2">备案号： <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #ffffff;">苏ICP备15000003号-1</a></p>
				        <p class="icon-3">网址:{{values3}}</p>
				        <p class="icon-4">地址:{{values4}}</p>
				    </div>
				    <div class="wrapper clearfix">
				      <p>版权所有：{{values5}}</p>
				    </div>
				  </div>
				</div>
			</div>
	    <div class="ewmmod">
	    	<div class="">公众号</div>
				<img src="../assets/images/footcode1.png" >
	    </div>
			<div class="ewmmod">
				<div class="">视频号</div>
				<img src="../assets/images/footcode2.png" >
			</div>
			<div class="ewmmod">
				<div class="">抖音</div>
				<img src="../assets/images/footcode3.png" >
			</div>
			
			<div class="friendshiplink">
				<div>友情链接：</div>
				<a v-for="(item,index) in linklistinfo" :key="index" :href="item.link" target="_blank">{{item.name}}</a>
			</div>
	  </div>
		<div class="r-links">
		  <div class="md-pc">
		    <div class="gouwu" >
		        <a href="https://shuanggou.tmall.com/?spm=a220o.1000855.1997427721.d4918089.2b2f4010pfjX53" target="_blank"><img src="../assets/images/tianmao.png" height="auto" style="width: 50px!important;top: -40px;left: -10px;position: absolute;"></a>
		        <a href="https://mall.jd.com/index-700599.html?from=pc" target="_blank"><img src="../assets/images/jingdong.png" height="auto" style="width: 50px!important;top: 15px;left: -40px;position: absolute;"></a>
		        <a href="https://shuanggou.suning.com/?pcode=12298670135" target="_blank"><img src="../assets/images/suning.png" height="auto" style="width: 50px!important;top: 70px;left: -10px;position: absolute;"></a>
		    </div> 
		  </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tyfooter',
		props: {
			pageind: String,
		},
		data(){
			return{
				isshow:this.COMMON.isshow(),
				pageind1:this.pageind,
				values1:'',
				values2:'',
				values3:'',
				values4:'',
				values5:'',
				linklistinfo:[]
			}
		},
		created() {
			
		},
		mounted() {
			let that=this
			window.onresize= (e) => {
				that.isshow = that.COMMON.isshow()
			}
			that.$axios.post('/w/base').then(function (response) {
				that.values1 = response.data[0].values
				that.values2 = response.data[1].values
				that.values3 = response.data[2].values
				that.values4 = response.data[3].values
				that.values5 = response.data[4].values
			}).catch(function (error) {
					console.log(error);
			});
			that.$axios.post('/w/friendshiplink').then(function (response) {
				that.linklistinfo = response.data
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			
		}
				
	}
</script>

<style>
	.footer{padding-top: 50px;padding-bottom: 50px;background-color: rgba(0,0,0,0.6);position: relative;}
	.mububg{
			position: absolute;top: 0px;z-index: -1;
			width: 100%;
			height: 100%;
			background: url(../assets/images/newsbg.jpg) 0 bottom repeat-x #efeff0;
	}
	.mububg1{
			position: absolute;top: 0px;z-index: -1;
			width: 100%;
			height: 100%;
			background: url(../assets/images/n_container_bg.jpg) 0 bottom repeat-x #efeff0;
	}
	.footer-wrap{}
	.footer-nav{ text-align: center; font-size: 0; }
	.footer-nav a{ font-size: 14px; color: #fff; line-height: 24px; margin: 0 10px; white-space: nowrap;}
	.footer-links{ display: none;}
	.footer-wrap .title{ font-size: 16px; color: #fff; line-height: 24px; padding-bottom: 8px; border-bottom: 1px solid rgba(255,255,255,0.1); font-weight: bold;}
	.footer-wrap .wrapper{ padding: 20px 0 0 0; position: relative;text-align: center;}
	.links-container{ margin: 0 20px;}
	.links-next, .links-prev{ width: 14px; height: 20px; background-size: 60%; margin-top: -10px;}
	.links-next{ right: 0;}
	.links-prev{ left: 0;}
	.links-container a{ width: auto; margin: 0 5px; font-size: 12px; color: #fff; line-height: 30px; height: auto;}
	.footer-wrap .wrapper p{ font-size: 14px;display: inline-block;margin-right:26px; color: #fff; line-height: 24px; padding: 8px 0 8px 25px; background-position: 0 10px; background-repeat: no-repeat; background-size: 20px;}
	.footer-wrap .icon-1{ background-image: url(../assets/images/icon-foot-1.png);}
	.footer-wrap .icon-2{ background-image: url(../assets/images/icon-foot-2.png);}
	.footer-wrap .icon-3{ background-image: url(../assets/images/icon-foot-3.png);}
	.footer-wrap .icon-4{ background-image: url(../assets/images/icon-foot-4.png);}
	.footer-wrap .right a{ display: block; width: 60px; height: 24px; text-align: center; line-height: 24px; font-size: 12px; color: #fff; background-color: #119e7f; margin-left: -25px; margin-top: 10px;}
	.footer-wrap .qrcode{ text-align: center; padding: 5px 0 10px; display: none;}
	.footer-wrap .qrcode img{ margin: 0 5px;}
	.footer-nav a{ font-size: 20px; margin: 0 15px;color: #fff;font-family: 'syst'}
	.footer-nav a:hover{color: #119e7f}
	  .footer-links{ display: block;}
	  .footer-wrap .right a{ display: inline-block; margin-left: 10px; vertical-align: top; margin-top: -3px;}
	  .footer-contact .qrcode{ display: block;}
	  .container-2{ max-width: 1000px; margin: 0 auto; padding: 0;}
		
		.r-links {
		    position: fixed;
		    right: 20px;
		    bottom: 16%;
		    z-index: 8;
		}
		.gouwu{
			background:url(../assets/images/right.png) no-repeat;background-size: 100%;width: 100px;height: 80px;position: relative;
		}
		.gouwu img{display: none;}
		.gouwu:hover img{display: block}
		.ewmmod{
			width: 8rem;
			margin-top: -0.5rem;
			margin-left: 1rem;
		}
		.ewmmod div{
			font-size: 16px; color: #fff;
			margin-bottom: 0.5rem;
		}
		.ewmmod img{width: 100%;}
		.friendshiplink{
			position: absolute;
			bottom: 30px;
			color: #fff;line-height: 24px;font-size: 14px;
			display: flex;
			justify-content: flex-start;
		}
		.friendshiplink a{color: #ffffff;margin-right: 10px;}
		
		.footerpc{
			display: flex;justify-content: center;
		}
		.footerph .ewmmod{
			display: inline-block;
			width: 6rem;
			margin-top: 10px;
			margin-bottom: 10px;
		}
		.footerph .footer-nav a{
			font-size: 16px;
		}
</style>
